export function barcodeLayout(el) {
  const width = el.rotation % 180 === 0 ? el.w : el.h;
  const height = el.rotation % 180 === 0 ? el.h : el.w;
  const fontSize = el.textFontSize ?? 2;
  const captionHeight = el.showText ? fontSize * 1.2 : 0;
  const barHeight = Math.max(0.1, height - captionHeight);
  const captionOffset = {
    0: [0, barHeight],
    90: [-barHeight, 0],
    180: [0, -barHeight],
    270: [barHeight, 0],
  };
  return { width, height, fontSize, captionHeight, barHeight, captionOffset: captionOffset[el.rotation] || captionOffset[0] };
}
